export default __webpack_public_path__ + "static/media/green_flag.c7c02d64.svg";